"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppTitle = exports.makeMyClasses = void 0;
const lib_palette_1 = __importDefault(require("@opsbase/lib-palette"));
const web_css_1 = __importDefault(require("@opsbase/web-css"));
const Button_1 = __importDefault(require("@opsbase/web-ui/Button"));
const react_1 = __importStar(require("react"));
const makeMyClasses = () => ({
    root: {
        padding: 4,
    },
    button: {
        borderRadius: 16,
        minWidth: 94,
    },
});
exports.makeMyClasses = makeMyClasses;
function AppTitle(props) {
    const { currentPage } = props;
    const myCss = (0, web_css_1.default)(exports.makeMyClasses);
    return (0, react_1.useMemo)(() => {
        if (!(currentPage === null || currentPage === void 0 ? void 0 : currentPage.label))
            return null;
        return (react_1.default.createElement("div", { className: myCss.root },
            react_1.default.createElement(Button_1.default, { classes: { root: myCss.button }, color: lib_palette_1.default.primary, label: currentPage.label() })));
    }, [currentPage, myCss]);
}
exports.AppTitle = AppTitle;
exports.default = AppTitle;
